import img1 from "../assets/imgs/group/1.png";
import img2 from "../assets/imgs/group/2.png";
import img3 from "../assets/imgs/group/4.png";
import img4 from "../assets/imgs/group/5.png";

export const users = [
  { name: "Leisure", img: img1 },
  { name: "Activism", img: img2 },
  { name: "MBA", img: img3 },
  { name: "Philosophy", img: img4 },
];
